import o from "react";
import n from "classnames";
import { mintelWhite as i, mintelBlack as r } from "mintel-tokens";
import { I as s } from "./Icon-ByeAHRM4.es.js";
import { u as _ } from "./DarkModeProvider-xoZXm3ct.es.js";
import './Image.css';const l = "2rem", d = "Image-module__container___mpv8M", g = "Image-module__image___9TOzK", u = "Image-module__overlay___ImmAc", I = "Image-module__icon___9cksu", e = {
  iconSize: l,
  container: d,
  image: g,
  overlay: u,
  icon: I
}, E = ({
  src: a,
  alt: t,
  iconOverlay: m
}) => {
  const c = _();
  return /* @__PURE__ */ o.createElement("div", { className: e.container }, m && /* @__PURE__ */ o.createElement("div", { className: e.icon }, /* @__PURE__ */ o.createElement(
    s,
    {
      size: e.iconSize,
      name: m,
      color: c ? i : r
    }
  )), /* @__PURE__ */ o.createElement(
    "img",
    {
      className: n(e.image, m && e.overlay),
      src: a,
      alt: t
    }
  ));
};
export {
  E as I
};
